import React, {useRef, useState} from "react";
import Windowheader from "./windowheader";
import {useDrag} from "react-dnd";
import {setGuiState} from "../../data/actions";
import {connect, useDispatch} from "react-redux";

const Window = ({gs, close, onContext, headline, icon, pos, children, id, type, edit, width}) => {
    const dispatch = useDispatch()

    const show = gs && gs.show || false
    const posx = gs && gs.x || 100
    const posy = gs && gs.y || 100
    const minim = gs && gs.minim || false

    const [{ isDragging }, drag, dragPreview] = useDrag(() => ({
        type: 'window',
        item: {
            id: id,
            type: 'window',
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                let dx = dropResult.clientOffset.x - (dropResult.initialClientOffset.x - dropResult.initialSourceClientOffset.x)
                let dy = dropResult.clientOffset.y - (dropResult.initialClientOffset.y - dropResult.initialSourceClientOffset.y)

                if( dx > window.innerWidth ) dx = window.innerWidth
                if( dy > window.innerHeight ) dy = window.innerHeight

                dispatch(setGuiState({
                    id: id,
                    x: dx,
                    y: dy,
                }))
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }))

    const _style = {
        top: posy,
        left: posx,
        position: 'fixed',
        width: width,
    };

    function update() {
        dispatch(setGuiState({
            id: id,
            minim: !minim,
        }))
    }

    function _close() {
        dispatch(setGuiState({
            id: id,
            show: false,
        }))
    }

    return (
        show?isDragging?null:<div ref={drag} style={_style}>
                <Windowheader close={_close} onContext={onContext} minimize={update} min={minim} headline={headline} id={id} width={width} icon={icon} edit={edit}/>
                {minim?null:children}
        </div>:null
    )
}

function mapStateToProps(state, other) {
    var itm = state.root.gui_state.find((itm) => {
        return itm.id === other.id
    });
    return {gs: itm}
}

export default connect(mapStateToProps)(Window)